export const useTransformScroll = (e) => {
  if (!e.deltaY) {
    return;
  }

  e.currentTarget.scrollLeft += e.deltaY + e.deltaX;
};
